import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import DefaultData from "../../CompanyData/DefaultData";
import { FaShoppingBag, FaUtensils } from "react-icons/fa";
const initialValues = {
  transactionId: "00000000-0000-0000-0000-000000000000",
  amount: 0,
  transactionType: "CREDIT",
  bookingType: "VISA",
  status: "",
  referenceNo: "",
  paymentGatewayNo: "",
  createdDate: new Date(),
  referenceId: "00000000-0000-0000-0000-000000000000",
};
const ReviewFlight = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [promocodes, setPromoCodes] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [flightBookingRequest, setFlightBookingRequest] = useState({});
  const [itinerary, setItinerary] = useState([]);
  const [searchQuery, setSearchQuery] = useState({});
  const [discount, setDiscount] = useState(0);
  const [travellers, setTravellers] = useState([]);
  const [priceChange, setPriceChange] = useState("");
  const [paymentGateway, setPaymentGateway] = useState("");
  const [paymentGatewayFee, setPaymentGatewayFee] = useState(0);
  const [paymentGatewayAmount, setPaymentGatewayAmount] = useState(0);
  const [baseFare, setBaseFare] = useState(0);
  const [tax, setTax] = useState(0);
  const [totalFare, setTotalFare] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);
  const [openPanel, setOpenPanel] = useState(null);
  const [baggageSelections, setBaggageSelections] = useState({});
  const [mealSelections, setMealSelections] = useState({});
  const handleFlightSearch = (e) => {
    navigate("/searchflights");
  };
  // 🧳 Add Baggage / 🍱 Meal
  const handleAddItem = (type, travellerIndex, item) => {
    const key = travellerIndex + 1; // start from 1 instead of 0
    if (type === "baggage") {
      setBaggageSelections((prev) => ({ ...prev, [key]: item }));
    } else if (type === "meal") {
      setMealSelections((prev) => ({ ...prev, [key]: item }));
    }
  };
  // 🧳 Remove Baggage / 🍱 Meal
  const handleRemoveItem = (type, travellerIndex) => {
    const key = travellerIndex + 1;
    if (type === "baggage") {
      setBaggageSelections((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });
    } else if (type === "meal") {
      setMealSelections((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });
    }
  };
  // ✅ Calculate totals
  const totalBaggageAmount = Object.values(baggageSelections).reduce(
    (sum, b) => sum + (b?.amount ? Number(b.amount) : 0),
    0,
  );

  const totalMealAmount = Object.values(mealSelections).reduce(
    (sum, m) => sum + (m?.amount ? Number(m.amount) : 0),
    0,
  );
  useEffect(() => {
    const total =
      parseFloat(flightBookingRequest.baseFare || 0) +
      parseFloat(flightBookingRequest.tax || 0) +
      parseFloat(flightBookingRequest.paymentGatewayAmount || 0) +
      parseFloat(flightBookingRequest.convenienceFee || 0) +
      totalBaggageAmount +
      totalMealAmount -
      discount;
    setTotalPrice(total);

    const fare =
      parseFloat(flightBookingRequest.baseFare || 0) +
      parseFloat(flightBookingRequest.tax || 0);
    setTotalFare(fare);
  }, [
    flightBookingRequest.baseFare,
    flightBookingRequest.tax,
    flightBookingRequest.paymentGatewayAmount,
    flightBookingRequest.convenienceFee,
    totalBaggageAmount,
    totalMealAmount,
    discount,
  ]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    flightBookingRequest.isHold = false;
    const dcBaggageTypes = Object.keys(baggageSelections).map((key) => {
      const index = Number(key) - 1;
      const t = travellers[index];
      const b = baggageSelections[key];
      return {
        travelerId: key,
        id: b.id,
        name: b.name || b.description,
        description: b.description,
        amount: b.amount.toString(),
      };
    });
    const dcMealTypes = Object.keys(mealSelections).map((key) => {
      const index = Number(key) - 1;
      const t = travellers[index];
      const m = mealSelections[key];
      return {
        travelerId: key,
        id: m.id,
        name: m.name || m.description,
        description: m.description,
        amount: m.amount.toString(),
      };
    });
    flightBookingRequest.dcMealTypes = dcMealTypes;
    flightBookingRequest.dcBaggageTypes = dcBaggageTypes;
    flightBookingRequest.totalPrice =
      parseFloat(flightBookingRequest.baseFare || 0) +
      parseFloat(flightBookingRequest.tax || 0) +
      parseFloat(flightBookingRequest.convenienceFee || 0) +
      totalBaggageAmount +
      totalMealAmount -
      discount;
    flightBookingRequest.totalFare = parseFloat(flightBookingRequest.baseFare || 0) +
      parseFloat(flightBookingRequest.tax || 0) +
      totalBaggageAmount +
      totalMealAmount;
    displayRazorpay(flightBookingRequest);
  };
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  }
  async function displayRazorpay(flightBookingRequest) {
    setBtnLoading(true);

    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js",
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      setBtnLoading(false);
      return;
    }

    try {
      const result = await apiService.post(
        config.MAKEPAYMENT +
          "?Amount=" +
          Math.round(parseFloat(totalPrice)) +
          "&PayRequest=" +
          paymentGateway +
          "&CompanyId=" +
          DefaultData?.DEFAULTCOMPANYID,
      );

      if (!result.succeeded) {
        alert("Payment initialization failed");
        setBtnLoading(false);
        return;
      }

      const { amount, id: order_id, currency, razorpayKey, name } = result.data;

      const options = {
        key: razorpayKey,
        amount,
        currency,
        name,
        description: "Flight Booking Fee",
        order_id,

        handler: async function (response) {
          try {
            InsertTransaction(
              response.razorpay_payment_id,
              "SUCCESS",
              flightBookingRequest,
            );
          } finally {
            setBtnLoading(false);
          }
        },

        modal: {
          ondismiss: function () {
            // 🔴 USER CLOSED POPUP
            console.log("Razorpay popup closed by user");
            setBtnLoading(false);
            flightBookingRequest.totalFare = parseFloat(flightBookingRequest.baseFare || 0) + parseFloat(flightBookingRequest.tax || 0);
          },
        },

        prefill: {
          name:
            flightBookingRequest.travellerInfos[0].firstName +
            " " +
            flightBookingRequest.travellerInfos[0].lastName,
          email: DefaultData?.DEFAULTCOMPANYEMAIL,
          contact: DefaultData?.DEFAULTCOMPANYPHONENUMBER,
        },

        notes: {
          address: "Hyderabad",
        },

        theme: {
          color: DefaultData?.THEMECOLOR1,
        },
      };

      const paymentObject = new window.Razorpay(options);

      // 🔴 PAYMENT FAILED EVENT
      paymentObject.on("payment.failed", function (response) {
        console.error("Payment Failed:", response.error);
        alert(response.error.description || "Payment failed");
        setBtnLoading(false);
      });

      paymentObject.open();
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again");
      setBtnLoading(false);
    }
  }
  const InsertTransaction = async (
    paymentGatewayNo,
    paymentStatus,
    flightBookingRequest,
  ) => {
    flightBookingRequest.paymentStatus = paymentStatus;
    flightBookingRequest.paymentGatewayNo = paymentGatewayNo;
    flightBookingRequest.discount = discount;
    flightBookingRequest.totalPrice =
      parseFloat(totalPrice);
    flightBookingRequest.couponCode = couponCode;
    flightBookingRequest.paymentGatewayFee = paymentGatewayFee;
    flightBookingRequest.gatewayAmount = totalPrice;
    flightBookingRequest.walletAmount = 0;
    flightBookingRequest.creditAmount = 0;
    flightBookingRequest.markup = 0;
    flightBookingRequest.paymentGateway = paymentGateway;
    flightBookingRequest.paymentGatewayAmount = paymentGatewayAmount;
    var result = await apiService.create(
      config.BOOKFLIGHT,
      flightBookingRequest,
    );
    setBtnLoading(false);
    navigate("/flight/booking/" + flightBookingRequest.flightBookingId);
  };
  function getTimeFromMins(mins) {
    var h = (mins / 60) | 0,
      m = (mins % 60) | 0;
    var durationformat = h + "h " + m + "m";
    return durationformat;
  }
  useEffect(() => {
    if (state === null) {
      navigate("/flight/search");
    } else if (params === null) {
      navigate("/flight/search");
    } else if (state.searchQuery === null) {
      navigate("/flight/search");
    } else {
      console.log(state);
    }
    var itinerary = state.flightBookingResponse.dcFlightLegs;
    setFlightBookingRequest(state.flightBookingResponse);
    setSearchQuery(itinerary.flightSearchRequest);
    setItinerary(itinerary);
    setTravellers(state.flightBookingResponse.travellerInfos);
    setBaseFare(state.flightBookingResponse.baseFare);
    setTax(state.flightBookingResponse.tax);
    setTotalFare(state.flightBookingResponse.totalFare);
    setTotalPrice(state.flightBookingResponse.totalPrice);
    setPaymentGateway(state.flightBookingResponse.paymentGateway);
    setPaymentGatewayFee(state.flightBookingResponse.paymentGatewayFee);
    setPaymentGatewayAmount(state.flightBookingResponse.paymentGatewayAmount);
    //GetPromoCodes();
  }, []);
  return (
    <div className="container-fluid" style={{ marginTop: "2px" }}>
      <div className="row">
        <div className="col-lg-8">
          <div className="bg-white shadow-md rounded p-3 p-sm-4 confirm-details">
            <h4 className="text-6 mb-3 mb-sm-4">Review Details</h4>
            <hr className="mx-n3 mx-sm-n4 mb-4" />
            {itinerary.length > 0 &&
              itinerary.map(
                (it) =>
                  it.dcDisplayLegs?.length > 0 &&
                  it.dcDisplayLegs.map((leg, index) => (
                    <>
                      <div className="card" key={index}>
                        <div className="card-header">
                          <div className="row align-items-center trip-title">
                            <div className="col-5 col-sm-auto text-center text-sm-start">
                              <h5 className="m-0 trip-place">
                                {leg.startSegment.city},{" "}
                                {leg.startSegment.airportCode}
                              </h5>
                            </div>
                            <div className="col-2 col-sm-auto text-8 text-black-50 text-center trip-arrow">
                              ➝
                            </div>
                            <div className="col-5 col-sm-auto text-center text-sm-start">
                              <h5 className="m-0 trip-place">
                                {leg.endSegment.city},{" "}
                                {leg.endSegment.airportCode}
                              </h5>
                            </div>
                            <div className="col-12 mt-1 d-block d-md-none" />
                            <div className="col-6 col-sm col-md-auto text-3 date">
                              {moment(
                                leg.startSegment.departureDateTime,
                              ).format("DD MMM YY")}
                            </div>
                            <div className="col-6 col-sm col-md-auto text-end order-sm-1">
                              <a
                                className="text-1"
                                data-bs-toggle="modal"
                                data-bs-target={
                                  "#fare-rules-" + it.flightLeg?.supplierLegId
                                }
                                href
                              >
                                Fare Rules
                              </a>
                            </div>
                            <div className="col col-md-auto text-center ms-auto order-sm-0">
                              {it.flightLeg?.refundable === "Refundable" ? (
                                <span className="badge bg-success fw-normal text-1">
                                  {it.flightLeg?.refundable}
                                </span>
                              ) : (
                                <span className="badge bg-danger fw-normal text-1">
                                  {it.flightLeg?.refundable}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-12 col-sm-3 text-center text-md-start d-lg-flex company-info">
                              <span className="align-middle">
                                <img
                                  className="img-fluid"
                                  width={"30px"}
                                  height={"30px"}
                                  alt
                                  src={
                                    "/assets/images/airlinelogos/" +
                                    leg.airlineData.airlineCode +
                                    ".png"
                                  }
                                />
                              </span>
                              <span className="align-middle ms-lg-2">
                                <span className="d-block text-2 text-dark mt-1 mt-lg-0">
                                  {leg?.airlineData?.airline}
                                </span>
                                <small className="text-muted d-block">
                                  {leg?.airlineData?.airlineCode +
                                    "-" +
                                    leg?.airlineData?.equimentType +
                                    "-" +
                                    leg?.airlineData?.flightNumber}
                                </small>{" "}
                              </span>{" "}
                            </div>
                            <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                              <span className="text-5 text-dark">
                                {moment(
                                  leg?.startSegment?.departureDateTime,
                                ).format("HH:mm")}
                              </span>
                              <small className="text-muted d-block">
                                {moment(
                                  leg?.startSegment?.departureDateTime,
                                ).format("DD MMM YY")}
                              </small>
                              <small className="text-muted d-block">
                                {leg?.startSegment?.airportName},{" "}
                                {leg?.startSegment?.city}
                              </small>{" "}
                            </div>
                            <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                              <span className="text-3 text-dark">
                                {getTimeFromMins(leg?.totalDuration)}
                              </span>
                              <small className="text-muted d-block">
                                Duration
                              </small>
                              <small className="text-muted d-block">
                                {leg?.stops === 0
                                  ? "Non Stop"
                                  : leg?.stops == 1
                                    ? "1 Stop"
                                    : leg?.stops + "Stops"}
                              </small>{" "}
                            </div>
                            <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                              <span className="text-5 text-dark">
                                {moment(
                                  leg?.endSegment?.arrivalDateTime,
                                ).format("HH:mm")}
                              </span>
                              <small className="text-muted d-block">
                                {moment(
                                  leg?.startSegment?.arrivalDateTime,
                                ).format("DD MMM YY")}
                              </small>
                              <small className="text-muted d-block">
                                {leg?.endSegment?.airportName},{" "}
                                {leg?.endSegment?.city}
                              </small>
                            </div>
                          </div>
                          <div
                            id={"fare-rules-" + it.flightLeg?.supplierLegId}
                            className="modal fade"
                            role="dialog"
                            aria-hidden="true"
                          >
                            <div
                              className="modal-dialog modal-lg modal-dialog-centered"
                              role="document"
                            >
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    Flight Details
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  />
                                </div>
                                <div className="modal-body">
                                  <ul
                                    className="nav nav-tabs"
                                    id="departureTab"
                                    role="tablist"
                                  >
                                    <li className="nav-item">
                                      {" "}
                                      <a
                                        className="nav-link active"
                                        id={
                                          "second-tab" +
                                          it.flightLeg?.supplierLegId
                                        }
                                        data-bs-toggle="tab"
                                        href={
                                          "#second" +
                                          it.flightLeg?.supplierLegId
                                        }
                                        role="tab"
                                        aria-controls={
                                          "second" + it.flightLeg?.supplierLegId
                                        }
                                        aria-selected="false"
                                      >
                                        Flight Details
                                      </a>{" "}
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <a
                                        className="nav-link"
                                        id={
                                          "third-tab" +
                                          it.flightLeg?.supplierLegId
                                        }
                                        data-bs-toggle="tab"
                                        href={
                                          "#third" + it.flightLeg?.supplierLegId
                                        }
                                        role="tab"
                                        aria-controls={
                                          "third" + it.flightLeg?.supplierLegId
                                        }
                                        aria-selected="false"
                                      >
                                        Baggage Details
                                      </a>{" "}
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <a
                                        className="nav-link"
                                        id={
                                          "fourth-tab" +
                                          it.flightLeg?.supplierLegId
                                        }
                                        data-bs-toggle="tab"
                                        href={
                                          "#fourth" +
                                          it.flightLeg?.supplierLegId
                                        }
                                        role="tab"
                                        aria-controls={
                                          "fourth" + it.flightLeg?.supplierLegId
                                        }
                                        aria-selected="false"
                                      >
                                        Cancellation Fee
                                      </a>{" "}
                                    </li>
                                  </ul>
                                  <div className="tab-content my-3">
                                    <div
                                      className="tab-pane fade show active"
                                      id={
                                        "second" + it.flightLeg?.supplierLegId
                                      }
                                      role="tabpanel"
                                      aria-labelledby="second-tab"
                                    >
                                      <div className="flight-details">
                                        <div className="row align-items-center trip-title mb-3">
                                          <div className="col col-sm-auto text-center text-sm-start">
                                            <span className="m-0 fs-14">
                                              {
                                                it.flightLeg?.dcDisplayLegs?.[0]
                                                  ?.startSegment?.city
                                              }
                                            </span>
                                          </div>
                                          <div className="col-auto text-10 text-black-50 text-center trip-arrow">
                                            ➝
                                          </div>
                                          <div className="col col-sm-auto text-center text-sm-start">
                                            <span className="m-0 fs-14">
                                              {
                                                it.flightLeg?.dcDisplayLegs?.[0]
                                                  ?.endSegment?.city
                                              }
                                            </span>
                                          </div>
                                          <div className="col col-sm-auto text-center text-sm-start">
                                            <span className="m-0 fs-14">
                                              Departure :{" "}
                                              {moment(
                                                it.flightLeg?.dcDisplayLegs?.[0]
                                                  ?.startSegment
                                                  ?.departureDateTime,
                                              ).format("Do MMM YY HH:mm")}
                                            </span>
                                          </div>
                                          <div className="col col-sm-auto text-center text-sm-start">
                                            <span className="m-0 fs-14">
                                              Arrival :{" "}
                                              {moment(
                                                it.flightLeg?.dcDisplayLegs?.[0]
                                                  ?.endSegment?.arrivalDateTime,
                                              ).format("Do MMM YY HH:mm")}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="tab-content my-3">
                                          {it.flightLeg?.dcSegments.length >
                                            0 &&
                                            it.flightLeg?.dcSegments.map(
                                              (seg) => (
                                                <>
                                                  <div className="row flex-row pt-4 px-md-4">
                                                    <div className="col-12 col-sm-3 text-center d-lg-flex company-info">
                                                      {" "}
                                                      <span className="align-middle">
                                                        <img
                                                          className="img-fluid"
                                                          alt
                                                          src={
                                                            "/assets/images/airlinelogos/" +
                                                            seg.tFAirlineData
                                                              ?.airlineCode +
                                                            ".png"
                                                          }
                                                        />{" "}
                                                      </span>{" "}
                                                      <span className="align-middle ms-lg-2">
                                                        {" "}
                                                        <span className="d-block text-1 text-dark">
                                                          {
                                                            seg.tFAirlineData
                                                              ?.airline
                                                          }
                                                        </span>{" "}
                                                        <small className="text-muted d-block">
                                                          {seg.tFAirlineData
                                                            ?.equimentType +
                                                            "-" +
                                                            seg.tFAirlineData
                                                              ?.flightNumber}
                                                        </small>{" "}
                                                      </span>{" "}
                                                    </div>
                                                    <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                                                      {" "}
                                                      <span className="text-5 text-dark">
                                                        {moment(
                                                          seg.tFDepartureData
                                                            .departureDateTime,
                                                        ).format("HH:mm")}
                                                      </span>{" "}
                                                      <small className="text-muted d-block">
                                                        {
                                                          seg.tFDepartureData
                                                            .airportName
                                                        }
                                                        ,{" "}
                                                        {
                                                          seg.tFDepartureData
                                                            .city
                                                        }
                                                        ,{" "}
                                                        {
                                                          seg.tFDepartureData
                                                            .terminal
                                                        }
                                                      </small>{" "}
                                                    </div>
                                                    <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                                                      {" "}
                                                      <span className="text-3 text-dark">
                                                        {getTimeFromMins(
                                                          seg.tFAirlineData
                                                            ?.duration,
                                                        )}
                                                      </span>{" "}
                                                      <small className="text-muted d-block">
                                                        Duration
                                                      </small>{" "}
                                                    </div>
                                                    <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                                                      {" "}
                                                      <span className="text-5 text-dark">
                                                        {moment(
                                                          seg.tFArrivalData
                                                            .arrivalDateTime,
                                                        ).format("HH:mm")}
                                                      </span>{" "}
                                                      <small className="text-muted d-block">
                                                        {
                                                          seg.tFArrivalData
                                                            .airportName
                                                        }
                                                        ,{" "}
                                                        {seg.tFArrivalData.city}
                                                        ,
                                                        {
                                                          seg.tFArrivalData
                                                            .terminal
                                                        }
                                                      </small>{" "}
                                                    </div>
                                                  </div>
                                                  {seg.tFAirlineData
                                                    .connectingTime !== 0 ? (
                                                    <div className="row flex-row pt-4 px-md-4">
                                                      <div className="col-12 col-sm-3 text-center d-lg-flex company-info">
                                                        <span className="badge bg-success">
                                                          CONNECTING TIME :{" "}
                                                          {getTimeFromMins(
                                                            seg.tFAirlineData
                                                              .connectingTime,
                                                          )}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </>
                                              ),
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade"
                                      id={"third" + it.flightLeg?.supplierLegId}
                                      role="tabpanel"
                                      aria-labelledby="third-tab"
                                    >
                                      <div className="table-responsive-md">
                                        <table className="table table-hover table-bordered">
                                          <thead>
                                            <tr>
                                              <th>&nbsp;</th>
                                              <td className="text-center">
                                                Cabin
                                              </td>
                                              <td className="text-center">
                                                Check-In
                                              </td>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td>Adult</td>
                                              <td className="text-center">
                                                {
                                                  it.flightLeg
                                                    ?.dcPriceDetails[0]
                                                    ?.dcAdults?.cabinClass
                                                }
                                              </td>
                                              <td className="text-center">
                                                {
                                                  it.flightLeg
                                                    ?.dcPriceDetails[0]
                                                    ?.dcAdults?.checkinBag
                                                }
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Child</td>
                                              <td className="text-center">
                                                {
                                                  it.flightLeg
                                                    ?.dcPriceDetails[0]?.dcKids
                                                    ?.cabinClass
                                                }
                                              </td>
                                              <td className="text-center">
                                                {
                                                  it.flightLeg
                                                    ?.dcPriceDetails[0]?.dcKids
                                                    ?.checkinBag
                                                }
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Infant</td>
                                              <td className="text-center">
                                                {
                                                  it.flightLeg
                                                    ?.dcPriceDetails[0]
                                                    ?.dcInfants?.cabinClass
                                                }
                                              </td>
                                              <td className="text-center">
                                                {
                                                  it.flightLeg
                                                    ?.dcPriceDetails[0]
                                                    ?.dcInfants?.checkinBag
                                                }
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade"
                                      id={
                                        "fourth" + it.flightLeg?.supplierLegId
                                      }
                                      role="tabpanel"
                                      aria-labelledby="fourth-tab"
                                    >
                                      <p className="fw-bold">
                                        Terms &amp; Conditions
                                      </p>
                                      <ul>
                                        <li>
                                          The penalty is subject before
                                          departure. No Changes are allowed
                                          after that.
                                        </li>
                                        <li>
                                          The charges are per passenger per
                                          sector.
                                        </li>
                                        <li>
                                          Partial cancellation is not allowed on
                                          tickets booked under special
                                          discounted fares.
                                        </li>
                                        <li>
                                          In case of no-show or ticket not
                                          cancelled within the stipulated time,
                                          only statutory taxes are refundable
                                          subject to Service Fee.
                                        </li>
                                        <li>
                                          No Baggage Allowance for Infants
                                        </li>
                                        <li>
                                          Airline penalty needs to be
                                          reconfirmed prior to any amendments or
                                          cancellation.
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {(it.dcBaggageTypes?.length > 0 || it.dcMealTypes?.length > 0) && (
                        <div className="container mt-4">
                          <h4>Traveller Extra Baggage &amp; Meals</h4>
                          {travellers
                            ?.filter((t) => t.travelerType !== "INFANT")
                            .map((t, index) => (
                              <div key={index} className="card mb-3 p-3 shadow-sm">
                                <h6>
                                  {index + 1} - {t.title}.{t.firstName}{" "}
                                  {t.lastName}
                                </h6>
                                <div>
                                  {/* Baggage Panel - only when options exist */}
                                  {it.dcBaggageTypes?.length > 0 && (
                                    <div className="mt-2">
                                      <button
                                        className="btn btn-link text-start w-100"
                                        onClick={() =>
                                          setOpenPanel(
                                            openPanel === `baggage-${index}`
                                              ? null
                                              : `baggage-${index}`,
                                          )
                                        }
                                      >
                                        🧳 Baggage Options
                                      </button>
                                      {openPanel === `baggage-${index}` && (
                                        <div className="row">
                                          {it.dcBaggageTypes.map((bg) => (
                                            <div key={bg.id} className="col-md-3 col-sm-6 mb-3">
                                              <div className="card text-center p-3">
                                                <FaShoppingBag className="text-primary mb-2" size={30} />
                                                <h6>{bg.description}</h6>
                                                <p>₹{bg.amount}</p>
                                                {baggageSelections[index + 1]?.id === bg.id ? (
                                                  <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => handleRemoveItem("baggage", index)}
                                                  >
                                                    Remove
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => handleAddItem("baggage", index, bg)}
                                                  >
                                                    Add
                                                  </button>
                                                )}
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  )}

                                  {/* Meal Panel - only when options exist */}
                                  {it.dcMealTypes?.length > 0 && (
                                    <div className="mt-2">
                                      <button
                                        className="btn btn-link text-start w-100"
                                        onClick={() =>
                                          setOpenPanel(
                                            openPanel === `meal-${index}`
                                              ? null
                                              : `meal-${index}`,
                                          )
                                        }
                                      >
                                        🍱 Meal Options
                                      </button>
                                      {openPanel === `meal-${index}` && (
                                        <div className="row">
                                          {it.dcMealTypes.map((meal) => (
                                            <div key={meal.id} className="col-md-3 col-sm-6 mb-3">
                                              <div className="card text-center p-3">
                                                <FaUtensils className="text-primary mb-2" size={30} />
                                                <h6>{meal.description}</h6>
                                                <p>₹{meal.amount}</p>
                                                {mealSelections[index + 1]?.id === meal.id ? (
                                                  <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => handleRemoveItem("meal", index)}
                                                  >
                                                    Remove
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => handleAddItem("meal", index, meal)}
                                                  >
                                                    Add
                                                  </button>
                                                )}
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                      )}
                    </>
                  )),
              )}
            <div className="col-xl-12 col-lg-12 col-md-12">
              {/* Overview */}
              <div className="card">
                <div className="card-header">
                  <h6 className="fw-semibold mb-0">Traveler Details</h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive-md">
                    <table className="table table-hover table-bordered">
                      <thead>
                        <tr>
                          <th>SNo.</th>
                          <th>Name</th>
                          <th>Gender</th>
                          <th>Type</th>
                          {params.isDomestic === "INTERNATIONAL" ? (
                            <th>DOB</th>
                          ) : (
                            ""
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {travellers.length > 0 &&
                          travellers.map((t, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>
                                {t.title}.{t.firstName} {t.lastName}
                              </td>
                              <td>{t.gender}</td>
                              <td>{t.travelerType}</td>
                              {params.isDomestic === "INTERNATIONAL" ? (
                                <td>
                                  {moment(t.dateOfBirth).format("DD MMM YYYY")}
                                </td>
                              ) : (
                                ""
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="full-width d-flex flex-column mb-2 position-relative">
                    <div className="row align-items-stat">
                      <div className="col-xl-4 col-lg-4 col-md-4"></div>
                      <div className="col-xl-8 col-lg-8 col-md-8">
                        <div className="text-end d-flex align-items-end justify-content-end">
                          {btnLoading === true ? (
                            <button
                              className="btn fw-medium btn-primary full-width"
                              type="button"
                              disabled
                            >
                              Processing...
                            </button>
                          ) : (
                            <>
                              <button
                                className="btn fw-medium btn-danger full-width m-2"
                                type="button"
                                onClick={handleFlightSearch}
                              >
                                Back to Fights List
                              </button>
                              <button
                                className="btn fw-medium btn-secondary full-width m-2"
                                type="button"
                                onClick={(e) => handleSubmit(e)}
                              >
                                Proceed To Payment
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Side Panel (Fare Details)
    ============================================= */}
        <div className="col-xl-4 col-lg-4 col-md-4">
          <div className="side-block card rounded-2 p-3">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h5 className="fw-semibold fs-6 mb-0">Payment Summary</h5>
            </div>
            <div className="card mb-4 mt-lg-0 mt-4">
              <div className="card-body py-2">
                <div className="price-summary">
                  <ul className="list-group">
                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 py-2 px-0">
                      Base Fare
                      <span className="fw-semibold text-dark">
                        INR{" "}
                        {parseFloat(flightBookingRequest.totalFare).toFixed(2)}
                      </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 py-2 px-0">
                      Convenience Fee
                      <span class="fw-semibold text-dark">
                        INR{" "}
                        {(
                          parseFloat(
                            flightBookingRequest.paymentGatewayAmount,
                          ) + parseFloat(flightBookingRequest.convenienceFee)
                        ).toFixed(2)}
                      </span>
                    </li>
                    {/* Extra Baggage Total */}
                    {totalBaggageAmount > 0 && (
                      <li className="list-group-item d-flex justify-content-between align-items-center border-0 py-2 px-0">
                        Extra Baggage
                        <span className="fw-semibold text-dark">
                          INR {totalBaggageAmount.toFixed(2)}
                        </span>
                      </li>
                    )}

                    {/* Meals Total */}
                    {totalMealAmount > 0 && (
                      <li className="list-group-item d-flex justify-content-between align-items-center border-0 py-2 px-0">
                        Meals
                        <span className="fw-semibold text-dark">
                          INR {totalMealAmount.toFixed(2)}
                        </span>
                      </li>
                    )}
                    {discount !== 0 ? (
                      <li className="list-group-item d-flex justify-content-between align-items-center border-0 py-2 px-0">
                        Discount
                        <span class="fw-semibold text-success">
                          INR {discount}
                        </span>
                      </li>
                    ) : (
                      ""
                    )}
                    {/* <li className="list-group-item d-flex justify-content-between align-items-center border-0 py-2 px-0">
                                                                    Tax & Service Fee
                                                                    <span className="fw-semibold text-dark">INR {Math.round(tax)}</span>
                                                                </li> */}
                    {priceChange !== "" ? (
                      <li className="list-group-item d-flex justify-content-between align-items-center border-0 py-2 px-0">
                        Note :
                        <span className="fw-semibold text-success">
                          {priceChange}
                        </span>
                      </li>
                    ) : (
                      ""
                    )}
                  </ul>
                </div>
              </div>
              <div className="card-footer bg-white border-top py-3">
                <div className="d-flex align-items-center justify-content-between">
                  <p className="fw-semibold text-muted-2 mb-0">Total Price</p>
                  <p className="fw-semibold text-primary mb-0">
                    INR{" "}
                    {Math.round(
                      parseFloat(flightBookingRequest.baseFare) +
                        parseFloat(flightBookingRequest.tax) +
                        parseFloat(flightBookingRequest.paymentGatewayAmount) +
                        parseFloat(flightBookingRequest.convenienceFee) +
                        totalBaggageAmount +
                        totalMealAmount -
                        discount,
                    )}
                  </p>
                </div>
              </div>
              <div className="card border rounded-3">
                <div className="card-header">
                  <h4>Coupons &amp; Offers</h4>
                </div>
                <div className="card-body">
                  <div className="form-group position-relative">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Have a Coupon Code?"
                      name="couponCode"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                    ></input>
                    <Link className="position-absolute top-50 end-0 fw-semibold translate-middle text-primary disable">
                      Apply
                    </Link>
                    {/*promoCodeError === true ? <span className="fw-medium text-primary">Invalid coupon code</span> : ""*/}
                  </div>
                  <div className="mid-block mb-2">
                    <div className="paymntCardsoption-groups">
                      {promocodes.length > 0 &&
                        promocodes.map((pc, index) => (
                          <div className="single-paymntCardsoption d-block position-relative mb-2">
                            <div className="paymnt-line active d-flex align-items-center justify-content-start">
                              <div className="position-relative text-center">
                                <div className="form-check lg mb-0">
                                  <input
                                    className="form-check-input"
                                    style={{ border: "1px solid" }}
                                    type="radio"
                                    name="coupons"
                                    id="coupons"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="coupons"
                                  />
                                </div>
                              </div>
                              <div className="paymnt-line-caps d-flex align-items-center justify-content-start">
                                <div className="paymnt-caps-details ps-2">
                                  <span className="text-uppercase d-block fw-semibold text-md text-dark lh-2 mb-0">
                                    {pc.code}
                                  </span>
                                  <span className="text-sm text-muted lh-2">
                                    {pc.description}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Side Panel End */}
      </div>
    </div>
  );
};

export default ReviewFlight;
